export default __webpack_public_path__ + "static/media/motherboard_power.138cd413.gif";